const InternationalScreen = () => {
  
    return (
       <p>International Screen here</p>
    )
}

export default InternationalScreen